import { Switch, Router as ReactRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import configConstants from 'config/constants'

import { STRING } from 'resources'
import { APP_URLS } from 'resources/urls'

import { WithAnalyticsHandlers } from 'models/Analytics/components'
import generalActions from 'models/General/actions'
import generalSelectors from 'models/General/selectors'

import CustomModal from 'components/CustomModal'
import NavMenu from 'components/NavMenu'
import Footer from 'components/Footer'

import LandingPage from 'screens/LandingPage'

import SignOut from 'screens/SignOut'
import SignIn from 'screens/SignIn'
import SignInCodeVerification from 'screens/SignInCodeVerification'
import NetworkError from 'screens/NetworkError'
import Root from 'screens/Root'
import LockedScreen from 'screens/LockedScreen/LockedScreen'

// Reklaim
import Jackpot from 'screens/Jackpot'
import Protect from 'screens/Protect'
import ProtectSigning from 'screens/Protect/ProtectSigning'
import RedemptionStore from 'screens/RedemptionStore'
import Wallet from 'screens/Wallet'
import WalletCryptoRedemption from 'screens/Wallet/WalletRedemptions/CryptoRedemption'
import WalletSharesRedemption from 'screens/Wallet/WalletRedemptions/SharesRedemption'
import RedemptionSocialShare from 'screens/Wallet/RedemptionSocialShare'
import SharesSigning from 'screens/Wallet/SharesSigning'
import SharesSigningSuccess from 'screens/Wallet/SharesSigningSuccess'

// Debug only
import KilliIcons from 'screens/KilliIcons'
import DesignSystem from 'screens/DesignSystem'

import history from './history'
import InitializeApp from './InitializeApp'
import Route from './Route'
import RoutesHandler from './RoutesHandler'
import ScrollToTop from './ScrollToTop'

import { LayoutContainer, MainContainer, NavMenuContainer, FooterContainer } from './styles'

export const Router = ({ isOpenModal, closeModal, modalTitle = '', modalMessage = '' }) => (
  <>
    <ReactRouter history={history}>
      <ScrollToTop />
      <Switch>
        <Route exact path="/download" component={LandingPage} />
        <Route exact path="/network-error" component={NetworkError} />
        <InitializeApp>
          <WithAnalyticsHandlers>
            <RoutesHandler>
              <LayoutContainer>
                <NavMenuContainer>
                  <NavMenu />
                </NavMenuContainer>
                <MainContainer>
                  <Switch>
                    <Route exact path="/" component={Root} />
                    <Route exact path="/sign-out" component={SignOut} />
                    <Route exact path="/sign-in" component={SignIn} />
                    <Route exact path="/verify-code" component={SignInCodeVerification} />

                    <Route isAuthenticatedRoute exact path="/jackpot" component={Jackpot} />
                    <Route isAuthenticatedRoute exact path="/protect" component={Protect} />
                    <Route isAuthenticatedRoute exact path="/protect/signing" component={ProtectSigning} />
                    <Route isAuthenticatedRoute exact path="/store" component={RedemptionStore} />
                    <Route isAuthenticatedRoute exact path="/wallet" component={Wallet} />
                    <Route
                      isAuthenticatedRoute
                      exact
                      path="/wallet/redemptions/crypto"
                      component={WalletCryptoRedemption}
                    />
                    <Route
                      isAuthenticatedRoute
                      exact
                      path="/wallet/redemptions/share"
                      component={RedemptionSocialShare}
                    />
                    <Route
                      isAuthenticatedRoute
                      exact
                      path="/wallet/redemptions/shares"
                      component={WalletSharesRedemption}
                    />
                    <Route
                      isAuthenticatedRoute
                      exact
                      path="/wallet/redemptions/shares/signing"
                      component={SharesSigning}
                    />
                    <Route
                      isAuthenticatedRoute
                      exact
                      path="/wallet/redemptions/shares/submitted"
                      component={SharesSigningSuccess}
                    />

                    <Route isAuthenticatedRoute exact path="/locked" component={LockedScreen} />

                    {/* Dev/Debug Screens */}
                    {configConstants.IS_NOT_PRODUCTION && <Route exact path="/killi-icons" component={KilliIcons} />}
                    {configConstants.IS_NOT_PRODUCTION && (
                      <Route exact path="/design-system" component={DesignSystem} />
                    )}

                    {/* Wildcard: If the path is not registered, redirect to root which will redirect accordingly */}
                    <Redirect from="*" to={APP_URLS.ROOT} />
                  </Switch>
                </MainContainer>
                <FooterContainer>
                  <Footer />
                </FooterContainer>
              </LayoutContainer>
            </RoutesHandler>
          </WithAnalyticsHandlers>
        </InitializeApp>
      </Switch>
    </ReactRouter>
    <CustomModal
      isOpen={isOpenModal}
      toggle={closeModal}
      title={modalTitle}
      message={modalMessage}
      buttonLabel={STRING.close}
    />
  </>
)

Router.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalTitle: PropTypes.string,
  modalMessage: PropTypes.string,
}

const mapStateToProps = (state) => ({
  isOpenModal: generalSelectors.getIsOpenModal(state),
  modalTitle: generalSelectors.getModalTitle(state),
  modalMessage: generalSelectors.getModalMessage(state),
  buttonLabel: generalSelectors.getButtonLabel(state),
})

const mapDispatchToProps = (dispatch) => ({
  closeModal: () => dispatch(generalActions.hideGeneralModal.success()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Router)
